import { getData } from 'helpers/services/services.utils';

type GetDataParams = {
  object: string;
  form?: string;
  key: string | number;
  locateInfo: string;
  fieldName?: string;
};

const cache = new Map<string, Promise<any>>();

function buildKey({ object, form, locateInfo, key }: GetDataParams) {
  return `${object || ''}|${form || ''}|${locateInfo || ''}|${key ?? ''}`;
}

export async function cachedGetData(params: GetDataParams) {
  const cacheKey = buildKey(params);
  const { fieldName } = params;

  let pending = cache.get(cacheKey);
  if (!pending) {
    pending = (async () => {
      try {
        const result = await getData(params);
        if (!result || result.success === false) {
          cache.delete(cacheKey);
        }
        return result;
      } catch (error) {
        cache.delete(cacheKey);
        throw error;
      }
    })();
    cache.set(cacheKey, pending);
  }

  const result = await pending;
  return { ...result, fieldName };
}

export function clearGetDataCache() {
  cache.clear();
}
